import { siteContent } from "../../content/siteContent";

export function Testimonials() {
  const { testimonials } = siteContent;

  return (
    <section className="home-testimonials home-section" aria-labelledby="home-testimonials-title">
      <div className="home-shell">
        <p className="home-eyebrow">{testimonials.eyebrow}</p>
        <h2 id="home-testimonials-title" className="home-editorial-heading">
          {testimonials.title}
        </h2>
        <p className="home-testimonials__notice">{testimonials.placeholderNotice}</p>
        <div className="home-testimonials__grid">
          {testimonials.items.map((testimonial, index) => (
            <figure key={index}>
              <blockquote>{testimonial.quote}</blockquote>
              <figcaption>{testimonial.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
